import type { ReactNode } from "react";

type SectionShellProps = {
  id: string;
  num: string;
  eyebrow: string;
  title: string;
  desc?: string;
  tone?: "paper" | "tint";
  children: ReactNode;
};

export default function SectionShell({
  id,
  num,
  eyebrow,
  title,
  desc,
  tone = "paper",
  children,
}: SectionShellProps) {
  return (
    <section id={id} className="w-full px-4 py-6 md:px-6 md:py-8">
      <div className="mx-auto w-full max-w-[1200px]">
        <div
          className={[
            "rounded-2xl border border-background-200/70 p-5 md:p-9",
            tone === "tint" ? "bg-background-100" : "bg-background-50",
          ].join(" ")}
        >
          <div className="flex flex-col gap-3 border-b border-background-200/70 pb-6 md:flex-row md:items-end md:justify-between md:pb-7">
            <div className="max-w-2xl">
              <div className="flex items-center gap-3">
                <span className="font-heading text-3xl font-black leading-none text-accent-500 md:text-4xl">
                  {num}
                </span>
                <span className="text-xs font-medium tracking-[0.28em] text-secondary-700">
                  {eyebrow}
                </span>
              </div>
              <h2 className="mt-3 font-heading text-2xl font-bold leading-tight text-foreground-950 md:text-[32px]">
                {title}
              </h2>
            </div>
            {desc ? (
              <p className="max-w-md text-sm leading-7 text-foreground-600 md:text-[15px]">
                {desc}
              </p>
            ) : null}
          </div>
          <div className="pt-7 md:pt-9">{children}</div>
        </div>
      </div>
    </section>
  );
}